// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"646":"5238154a","1279":"7b99a812","6674":"9a655a13","7625":"cfa42df9","8793":"a51722d9","9931":"5238154a"}[chunkId] + ".chunk.css";
};